/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradeMutationResponse,
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradePathParams,
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade401,
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade500,
} from "../../types/classPlanningGradeAndFrequenceConfigurationController/PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade } from "../../clients/classPlanningGradeAndFrequenceConfigurationController/patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade.ts";

export const patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradeMutationKey =
  () =>
    [
      {
        url: "/api/v1/classroomdiscipline/grade-and-frequence/class-modules/:classModuleId/disciplines/:disciplineId/included-in-grade",
      },
    ] as const;

export type PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradeMutationKey =
  ReturnType<
    typeof patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradeMutationKey
  >;

export function patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradeMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey =
    patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradeMutationKey();
  return mutationOptions<
    PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradeMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade401
      | PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade500
    >,
    {
      classModuleId: PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradePathParams["classModuleId"];
      disciplineId: PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradePathParams["disciplineId"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ classModuleId, disciplineId }) => {
      return patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade(
        classModuleId,
        disciplineId,
        config,
      );
    },
  });
}

/**
 * @description Inverte a flag IsIncludedInGradeCalculation da Disciplina no Módulo. Se a configuração ainda não existir, ela é criada. Retorna o estado atualizado da configuração. **(Requer Authorization para autenticação)**
 * @summary Alternar 'Considerar no cálculo de nota' (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/grade-and-frequence/class-modules/:classModuleId/disciplines/:disciplineId/included-in-grade}
 */
export function usePatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradeMutationResponse,
      ResponseErrorConfig<
        | PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade401
        | PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade500
      >,
      {
        classModuleId: PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradePathParams["classModuleId"];
        disciplineId: PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradePathParams["disciplineId"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradeMutationKey();

  const baseOptions =
    patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradeMutationOptions(
      config,
    ) as UseMutationOptions<
      PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradeMutationResponse,
      ResponseErrorConfig<
        | PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade401
        | PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade500
      >,
      {
        classModuleId: PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradePathParams["classModuleId"];
        disciplineId: PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradePathParams["disciplineId"];
      },
      TContext
    >;

  return useMutation<
    PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradeMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade401
      | PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade500
    >,
    {
      classModuleId: PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradePathParams["classModuleId"];
      disciplineId: PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradePathParams["disciplineId"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradeMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade401
      | PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade500
    >,
    {
      classModuleId: PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradePathParams["classModuleId"];
      disciplineId: PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradePathParams["disciplineId"];
    },
    TContext
  >;
}
